<template>
<div class="chapter">
<div class="inner_page">
<div id="fm02">
<p class="also">A<span class="small1">LSO BY</span> J<span class="small1">OHN</span> R<span class="small1">ECHY</span></p>
<p class="also1"><span>NOVELS</span></p>
<p class="also2"><em class="italic">City of Night</em></p>
<p class="also3"><em class="italic">Numbers</em></p>
<p class="also3"><em class="italic">This Day’s Death</em></p>
<p class="also3"><em class="italic">The Vampires</em></p>
<p class="also3"><em class="italic">The Fourth Angel</em></p>
<p class="also3"><em class="italic">Rushes</em></p>
<p class="also3"><em class="italic">Bodies and Souls</em></p>
<p class="also3"><em class="italic">Marilyn’s Daughter</em></p>
<p class="also3"><em class="italic">The Miraculous Day of Amalia Gómez</em></p>
<p class="also1"><span>NONFICTION</span></p>
<p class="also2"><em class="italic">The Sexual Outlaw: A Documentary</em></p>
<p class="also1"><span>PLAYS</span></p>
<p class="also2"><em class="italic">Rushes</em></p>
<p class="also3"><em class="italic">Tigers Wild</em></p>
<p class="also3"><em class="italic">Momma as She Became—but Not As She Was (one-act)</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Also_by_John_Rechy.vue?4106246e